/* Dr Sknn Treatment V3 — carousel and contained consultation/pricing journeys. */
(function () {
  "use strict";

  var root = document.querySelector("[data-drsknn-lines-wrinkles]");
  if (!root || root.dataset.linesWrinklesReady === "true") return;
  root.dataset.linesWrinklesReady = "true";

  var activeOverlay = null;
  var lastTrigger = null;
  var returnUrl = "";
  var pricingPromise = null;
  var suppressPricingClose = false;
  var nestedPricingIsolation = null;
  var nestedPricingObserver = null;
  var resultIndex = 0;
  var resultZoom = 1;
  var zoomPositionToken = 0;
  var zoomDrag = null;
  var zoomDragMoved = false;
  var preserveOriginBehaviour = root.dataset.treatmentHandle === "origin-laser-v3-preview";

  function q(selector, context) {
    return (context || document).querySelector(selector);
  }

  function qa(selector, context) {
    return Array.prototype.slice.call((context || document).querySelectorAll(selector));
  }

  function initJumpNavigation() {
    if (preserveOriginBehaviour) return;
    var jump = q(".drsknn-treatment-v3__jump", root);
    var scroller = q(".drsknn-treatment-v3__jump-inner", jump);
    var links = qa('a[href^="#treatment-"]', jump);
    if (!jump || !scroller || !links.length) return;

    var frame = 0;
    function updateOverflowCue() {
      frame = 0;
      var maximum = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      var state = "none";
      var cue = "";
      if (maximum > 2) {
        if (scroller.scrollLeft <= 2) {
          state = "start";
          cue = "More →";
        } else if (scroller.scrollLeft >= maximum - 2) {
          state = "end";
          cue = "← More";
        } else {
          state = "middle";
          cue = "More ↔";
        }
      }
      jump.setAttribute("data-tv3-jump-overflow", state);
      jump.setAttribute("data-tv3-jump-cue", cue);
    }

    function scheduleOverflowCue() {
      if (frame) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(updateOverflowCue);
    }

    function markCurrent(link) {
      links.forEach(function (candidate) {
        if (candidate === link) candidate.setAttribute("aria-current", "location");
        else candidate.removeAttribute("aria-current");
      });
    }

    links.forEach(function (link) {
      link.addEventListener("click", function () { markCurrent(link); });
    });

    if (typeof window.IntersectionObserver === "function") {
      var sections = links.map(function (link) {
        try { return q(link.getAttribute("href"), root); } catch (_) { return null; }
      }).filter(Boolean);
      var sectionToLink = new Map();
      links.forEach(function (link) {
        var section = null;
        try { section = q(link.getAttribute("href"), root); } catch (_) {}
        if (section) sectionToLink.set(section, link);
      });
      var observer = new window.IntersectionObserver(function (entries) {
        var visible = entries.filter(function (entry) { return entry.isIntersecting; })
          .sort(function (a, b) { return b.intersectionRatio - a.intersectionRatio; });
        if (visible[0] && sectionToLink.has(visible[0].target)) markCurrent(sectionToLink.get(visible[0].target));
      }, { rootMargin: "-18% 0px -68% 0px", threshold: [0, .05, .2] });
      sections.forEach(function (section) { observer.observe(section); });
    } else {
      markCurrent(links[0]);
    }

    scroller.addEventListener("scroll", scheduleOverflowCue, { passive: true });
    window.addEventListener("resize", scheduleOverflowCue, { passive: true });
    updateOverflowCue();
  }

  function initProofFallback() {
    if (preserveOriginBehaviour) return;
    var section = q(".drsknn-treatment-v3__results-live", root);
    var host = q("[data-drsknn-proof-preview]", section);
    if (!section || !host || !q(".dps-loading", host)) return;

    var timeout = null;
    var started = false;
    var viewport = null;
    function startTimeout() {
      if (started) return;
      started = true;
      if (viewport) viewport.disconnect();
      if (!q(".dps-loading", host) || q(".dps-preview-grid, .dps-preview", host)) return;
      timeout = window.setTimeout(function () {
        var loading = q(".dps-loading", host);
        if (!loading || q(".dps-preview-grid, .dps-preview", host)) return;
        section.setAttribute("data-tv3-proof-state", "timeout");
        loading.classList.add("drsknn-treatment-v3__proof-fallback");
        loading.setAttribute("role", "status");
        loading.setAttribute("aria-live", "polite");
        loading.innerHTML = "<strong>Results are taking longer than expected.</strong><span>Use the complete Before &amp; After Studio link below while this panel reconnects.</span>";
      }, 10000);
    }

    if (typeof window.MutationObserver === "function") {
      var observer = new window.MutationObserver(function () {
        if (!q(".dps-preview-grid, .dps-preview", host)) return;
        if (timeout !== null) window.clearTimeout(timeout);
        if (viewport) viewport.disconnect();
        section.setAttribute("data-tv3-proof-state", "ready");
        observer.disconnect();
      });
      observer.observe(host, { childList: true, subtree: true });
    }

    // Match the proof loader's visibility margin; off-screen waiting is not a load failure.
    if (typeof window.IntersectionObserver === "function") {
      viewport = new window.IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) startTimeout();
      }, { rootMargin: "700px 0px" });
      viewport.observe(host);
    } else {
      startTimeout();
    }
  }

  function nestedPricingBackdrop() {
    return q(".drsknn-pricing-modal-backdrop.drsknn-pricing-modal-open");
  }

  function nestedPricingIsOpen() {
    return Boolean(nestedPricingBackdrop());
  }

  function restoreNestedPricingIsolation() {
    if (!nestedPricingIsolation) return;
    var overlay = nestedPricingIsolation.overlay;
    var dialog = nestedPricingIsolation.dialog;
    overlay.inert = nestedPricingIsolation.inert;
    if (!nestedPricingIsolation.hadInert) overlay.removeAttribute("inert");
    if (nestedPricingIsolation.ariaHidden === null) overlay.removeAttribute("aria-hidden");
    else overlay.setAttribute("aria-hidden", nestedPricingIsolation.ariaHidden);
    overlay.removeAttribute("data-tv3-nested-pricing-active");
    if (dialog) {
      if (nestedPricingIsolation.ariaModal === null) dialog.removeAttribute("aria-modal");
      else dialog.setAttribute("aria-modal", nestedPricingIsolation.ariaModal);
    }
    document.documentElement.classList.remove("drsknn-tv3-nested-pricing-open");
    nestedPricingIsolation = null;
  }

  function syncNestedPricingIsolation() {
    if (preserveOriginBehaviour) return;
    var overlay = overlayFor("pricing");
    var backdrop = nestedPricingBackdrop();
    var shouldSuspend = Boolean(
      overlay &&
      backdrop &&
      overlay.classList.contains("is-open") &&
      !overlay.contains(backdrop)
    );
    if (!shouldSuspend) {
      restoreNestedPricingIsolation();
      return;
    }
    if (nestedPricingIsolation) return;

    var dialog = q(':scope > [role="dialog"]', overlay) || q('[role="dialog"]', overlay);
    nestedPricingIsolation = {
      overlay: overlay,
      dialog: dialog,
      inert: Boolean(overlay.inert),
      hadInert: overlay.hasAttribute("inert"),
      ariaHidden: overlay.getAttribute("aria-hidden"),
      ariaModal: dialog ? dialog.getAttribute("aria-modal") : null
    };
    overlay.setAttribute("data-tv3-nested-pricing-active", "true");
    overlay.inert = true;
    overlay.setAttribute("aria-hidden", "true");
    if (dialog) dialog.setAttribute("aria-modal", "false");
    document.documentElement.classList.add("drsknn-tv3-nested-pricing-open");
  }

  function bindNestedPricingIsolation() {
    if (preserveOriginBehaviour || typeof window.MutationObserver !== "function") return;
    var backdrop = q(".drsknn-pricing-modal-backdrop");
    if (!backdrop) return;
    if (nestedPricingObserver) nestedPricingObserver.disconnect();
    nestedPricingObserver = new window.MutationObserver(syncNestedPricingIsolation);
    nestedPricingObserver.observe(backdrop, { attributes: true, attributeFilter: ["class", "aria-hidden"] });
    syncNestedPricingIsolation();
  }

  function initHeaderSearchBridge() {
    if (document.documentElement.dataset.drsknnHeaderSearchBridgeReady === "true") return;
    var compactSearch = q(".header .header-full-width-search");
    var compactForm = compactSearch && q("form.search", compactSearch);
    var compactInput = compactSearch && q('input[type="search"]', compactSearch);
    var compactSubmit = compactSearch && q('button[type="submit"]', compactSearch);
    var modalRoot = q(".header .header__search");
    var modalDetails = modalRoot && q("details", modalRoot);
    var modalInput = modalRoot && q('input[type="search"]', modalRoot);

    if (!compactForm || !compactInput || !compactSubmit || !modalRoot || !modalDetails || !modalInput) return;
    document.documentElement.dataset.drsknnHeaderSearchBridgeReady = "true";

    function setModalRootVisible(visible) {
      if (visible) {
        modalRoot.setAttribute("data-tv3-search-bridge", "true");
        modalRoot.style.setProperty("display", "block", "important");
      } else {
        modalRoot.removeAttribute("data-tv3-search-bridge");
        modalRoot.style.removeProperty("display");
      }
    }

    function openSearch(event) {
      if (compactInput.value.trim()) return;
      event.preventDefault();
      setModalRootVisible(true);
      modalDetails.open = true;
      window.requestAnimationFrame(function () {
        modalInput.focus({ preventScroll: true });
      });
    }

    compactSubmit.addEventListener("click", openSearch);
    compactForm.addEventListener("submit", openSearch);
    modalDetails.addEventListener("toggle", function () {
      if (modalDetails.open) {
        setModalRootVisible(true);
        window.requestAnimationFrame(function () {
          modalInput.focus({ preventScroll: true });
        });
        return;
      }
      setModalRootVisible(false);
    });
  }

  // This pilot owns its complete page journey, so remove the generic SEO block
  // if a cached storefront render injects it beneath the V3 section.
  function removeLegacyEnhancement() {
    qa(".drsknn-seo-enhancement").forEach(function (enhancement) {
      enhancement.remove();
    });
  }

  removeLegacyEnhancement();
  var legacySweep = window.setInterval(removeLegacyEnhancement, 250);
  window.setTimeout(function () {
    removeLegacyEnhancement();
    window.clearInterval(legacySweep);
  }, 15000);

  function initCarousel() {
    var viewport = q("[data-tv3-carousel]", root);
    var slides = qa("[data-tv3-carousel-slide]", root);
    var current = q("[data-tv3-carousel-current]", root);
    var prev = q("[data-tv3-carousel-prev]", root);
    var next = q("[data-tv3-carousel-next]", root);
    if (!viewport || !slides.length) return;

    var index = 0;
    var frame = 0;

    function nearestIndex() {
      var left = viewport.getBoundingClientRect().left;
      var best = 0;
      var distance = Infinity;
      slides.forEach(function (slide, slideIndex) {
        var candidate = Math.abs(slide.getBoundingClientRect().left - left);
        if (candidate < distance) {
          distance = candidate;
          best = slideIndex;
        }
      });
      return best;
    }

    function maximumStartIndex() {
      var maximumScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      var viewportLeft = viewport.getBoundingClientRect().left;
      var best = 0;
      var distance = Infinity;
      slides.forEach(function (slide, slideIndex) {
        var naturalLeft = slide.getBoundingClientRect().left - viewportLeft + viewport.scrollLeft;
        var candidate = Math.abs(naturalLeft - maximumScroll);
        if (candidate < distance) {
          distance = candidate;
          best = slideIndex;
        }
      });
      return best;
    }

    function setDirectionState(button, disabled) {
      if (!button) return;
      button.disabled = disabled;
      button.setAttribute("aria-disabled", disabled ? "true" : "false");
    }

    function update() {
      index = nearestIndex();
      if (current) current.textContent = String(index + 1);
      setDirectionState(prev, index === 0);
      setDirectionState(next, index >= maximumStartIndex());
    }

    function goTo(target) {
      index = Math.max(0, Math.min(maximumStartIndex(), target));
      var delta = slides[index].getBoundingClientRect().left - viewport.getBoundingClientRect().left;
      viewport.scrollBy({ left: delta, behavior: "smooth" });
      window.setTimeout(update, 320);
    }

    if (prev) prev.addEventListener("click", function () { goTo(nearestIndex() - 1); });
    if (next) next.addEventListener("click", function () { goTo(nearestIndex() + 1); });
    viewport.addEventListener("keydown", function (event) {
      if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
      event.preventDefault();
      goTo(nearestIndex() + (event.key === "ArrowRight" ? 1 : -1));
    });
    viewport.addEventListener("scroll", function () {
      if (frame) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(function () {
        frame = 0;
        update();
      });
    }, { passive: true });
    window.addEventListener("resize", update, { passive: true });
    update();
  }

  function initTreatmentVideos() {
    qa("[data-tv3-video-load]", root).forEach(function (button) {
      button.addEventListener("click", function () {
        var source = button.getAttribute("data-tv3-video-src") || "";
        if (!/^https:\/\/www\.youtube-nocookie\.com\/embed\/[A-Za-z0-9_-]+(?:\?|$)/.test(source)) return;
        var frame = document.createElement("iframe");
        frame.src = source;
        frame.title = button.getAttribute("data-tv3-video-title") || "Dr Sknn treatment video";
        frame.loading = "lazy";
        frame.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
        frame.allowFullscreen = true;
        frame.referrerPolicy = "strict-origin-when-cross-origin";
        button.replaceWith(frame);
      }, { once: true });
    });
  }

  function directBookingOverlay() {
    return q('[data-tv3-overlay="direct-booking"]', root);
  }

  function filterDirectAreas() {
    var overlay = directBookingOverlay();
    if (!overlay) return;
    var search = q("[data-tv3-direct-search]", overlay);
    var activeGroup = q("[data-tv3-direct-group]:not([hidden])", overlay);
    var empty = q("[data-tv3-direct-empty]", overlay);
    if (!activeGroup) return;
    var terms = String(search ? search.value : "").toLowerCase().trim().split(/\s+/).filter(Boolean);
    var visible = 0;
    qa("[data-tv3-direct-area-card]", activeGroup).forEach(function (card) {
      var name = String(card.getAttribute("data-tv3-direct-area-name") || "");
      var matches = terms.every(function (term) { return name.indexOf(term) !== -1; });
      card.hidden = !matches;
      if (matches) visible += 1;
    });
    if (empty) empty.hidden = visible !== 0;
  }

  function setDirectBookingGroup(slug, focusTab) {
    var overlay = directBookingOverlay();
    if (!overlay) return;
    var tabs = qa("[data-tv3-direct-group-tab]", overlay);
    var groups = qa("[data-tv3-direct-group]", overlay);
    var selected = null;
    tabs.forEach(function (tab) {
      var active = tab.getAttribute("data-tv3-direct-group-tab") === slug;
      tab.setAttribute("aria-selected", active ? "true" : "false");
      tab.tabIndex = active ? 0 : -1;
      if (active) selected = tab;
    });
    groups.forEach(function (group) {
      var active = group.getAttribute("data-tv3-direct-group") === slug;
      group.hidden = !active;
      group.setAttribute("aria-hidden", active ? "false" : "true");
    });
    filterDirectAreas();
    if (focusTab && selected) selected.focus({ preventScroll: true });
  }

  function resetDirectBookingPicker() {
    var overlay = directBookingOverlay();
    if (!overlay) return;
    var search = q("[data-tv3-direct-search]", overlay);
    var firstTab = q("[data-tv3-direct-group-tab]", overlay);
    if (search) search.value = "";
    if (firstTab) setDirectBookingGroup(firstTab.getAttribute("data-tv3-direct-group-tab") || "", false);
    else filterDirectAreas();
  }

  function initDirectBookingPicker() {
    var overlay = directBookingOverlay();
    if (!overlay) return;
    var tabs = qa("[data-tv3-direct-group-tab]", overlay);
    var search = q("[data-tv3-direct-search]", overlay);
    var consultationFallback = q("[data-tv3-direct-consultation]", overlay);
    tabs.forEach(function (tab, index) {
      tab.addEventListener("click", function () {
        setDirectBookingGroup(tab.getAttribute("data-tv3-direct-group-tab") || "", false);
      });
      tab.addEventListener("keydown", function (event) {
        if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
        event.preventDefault();
        var delta = event.key === "ArrowRight" ? 1 : -1;
        var next = tabs[(index + delta + tabs.length) % tabs.length];
        setDirectBookingGroup(next.getAttribute("data-tv3-direct-group-tab") || "", true);
      });
    });
    if (search) search.addEventListener("input", filterDirectAreas);
    if (consultationFallback) {
      consultationFallback.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        openOverlay("consultation", consultationFallback);
      });
    }
    qa("[data-tv3-direct-service-link]", overlay).forEach(function (link) {
      link.addEventListener("click", function () { link.setAttribute("aria-busy", "true"); });
    });
    resetDirectBookingPicker();
  }

  function relativeUrl(value) {
    try {
      var parsed = new URL(value, window.location.href);
      return parsed.pathname + parsed.search + parsed.hash;
    } catch (_) {
      return value;
    }
  }

  function overlayFor(name) {
    return q('[data-tv3-overlay="' + name + '"]', root);
  }

  function focusableElements(container) {
    return qa(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])',
      container
    ).filter(function (element) {
      return element.getAttribute("aria-hidden") !== "true" &&
        (element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0);
    });
  }

  function trapOverlayFocus(event) {
    if (!activeOverlay || event.key !== "Tab") return;
    var dialog = q('[role="dialog"]', activeOverlay);
    if (!dialog) return;
    var focusable = focusableElements(dialog);
    if (!focusable.length) {
      event.preventDefault();
      dialog.focus({ preventScroll: true });
      return;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    var active = document.activeElement;
    if (event.shiftKey && (active === first || active === dialog || !dialog.contains(active))) {
      event.preventDefault();
      last.focus({ preventScroll: true });
    } else if (!event.shiftKey && (active === last || active === dialog || !dialog.contains(active))) {
      event.preventDefault();
      first.focus({ preventScroll: true });
    }
  }

  function resetConsultation() {
    var chooser = q("[data-tv3-consultation-chooser]", root);
    var booking = q("[data-tv3-booking]", root);
    var frame = q("[data-tv3-booking-frame]", root);
    if (chooser) chooser.hidden = false;
    if (booking) booking.hidden = true;
    if (tv3ParentBridge) tv3ParentBridge.destroy();
    tv3ParentBridge = null;
    if (frame) frame.removeAttribute("src");
  }

  function closeOverlay(overlay, options) {
    if (!overlay || !overlay.classList.contains("is-open")) return;
    options = options || {};

    if (overlay.getAttribute("data-tv3-overlay") === "pricing") {
      restoreNestedPricingIsolation();
      if (!options.skipPricingClose) {
        var exactClose = q(".drsknn-pricing-modal-open [data-pricing-close-modal]");
        if (exactClose) {
          suppressPricingClose = true;
          exactClose.click();
          window.setTimeout(function () { suppressPricingClose = false; }, 0);
        }
        var guideClose = q("[data-pv3-guide]:not([hidden]) [data-pv3-guide-close]");
        if (guideClose) guideClose.click();
      }
    }

    overlay.classList.remove("is-open");
    overlay.setAttribute("aria-hidden", "true");
    document.body.classList.remove("drsknn-tv3-modal-open");
    activeOverlay = null;

    if (returnUrl) {
      window.history.replaceState(window.history.state || {}, "", relativeUrl(returnUrl));
      returnUrl = "";
    }

    if (overlay.getAttribute("data-tv3-overlay") === "consultation") resetConsultation();
    if (overlay.getAttribute("data-tv3-overlay") === "direct-booking") resetDirectBookingPicker();
    if (overlay.getAttribute("data-tv3-overlay") === "results") setResultZoom(1, false);
    if (lastTrigger && typeof lastTrigger.focus === "function") lastTrigger.focus({ preventScroll: true });
    lastTrigger = null;
  }

  function setPricingRoute() {
    var url = new URL(window.location.href);
    var pricingSlug = root.dataset.pricingSlug || "all";
    url.searchParams.set("price_route", "search");
    if (pricingSlug === "all") url.searchParams.delete("pricing");
    else url.searchParams.set("pricing", pricingSlug);
    url.hash = "";
    window.history.replaceState(window.history.state || {}, "", url.pathname + url.search);
  }

  function openOverlay(name, trigger) {
    var overlay = overlayFor(name);
    if (!overlay) return;
    if (activeOverlay && activeOverlay !== overlay) closeOverlay(activeOverlay);

    lastTrigger = trigger || document.activeElement;
    returnUrl = window.location.href;
    if (name === "pricing") setPricingRoute();

    activeOverlay = overlay;
    overlay.classList.add("is-open");
    overlay.setAttribute("aria-hidden", "false");
    document.body.classList.add("drsknn-tv3-modal-open");
    var dialog = q('[role="dialog"]', overlay);
    if (dialog) dialog.focus({ preventScroll: true });

    if (name === "pricing") {
      hydratePricing().then(function (loaded) {
        if (!loaded) return;
        bindNestedPricingIsolation();
        window.dispatchEvent(new PopStateEvent("popstate", { state: window.history.state || {} }));
      });
    }
    if (name === "direct-booking") {
      resetDirectBookingPicker();
      window.requestAnimationFrame(function () {
        var search = q("[data-tv3-direct-search]", overlay);
        if (search) search.focus({ preventScroll: true });
      });
    }
  }

  function openDetail(trigger) {
    if (!trigger) return;
    var overlay = overlayFor("detail");
    if (!overlay) return;
    var eyebrow = q("[data-tv3-detail-dialog-eyebrow]", overlay);
    var title = q("[data-tv3-detail-dialog-title]", overlay);
    var copy = q("[data-tv3-detail-dialog-copy]", overlay);
    if (eyebrow) eyebrow.textContent = trigger.getAttribute("data-tv3-detail-eyebrow") || "More information";
    if (title) title.textContent = trigger.getAttribute("data-tv3-detail-title") || "Clinical planning";
    if (copy) copy.textContent = trigger.getAttribute("data-tv3-detail-copy") || "Your clinician will explain this during consultation.";
    openOverlay("detail", trigger);
  }

  function resultSlides() {
    return qa("[data-tv3-carousel-slide]", root);
  }

  function resultCanvas() {
    return q("[data-tv3-result-canvas]", overlayFor("results"));
  }

  function setResultZoom(target, keepCentre) {
    var overlay = overlayFor("results");
    var canvas = resultCanvas();
    if (!overlay || !canvas) return;
    var oldWidth = canvas.scrollWidth || canvas.clientWidth || 1;
    var oldHeight = canvas.scrollHeight || canvas.clientHeight || 1;
    var centreX = (canvas.scrollLeft + canvas.clientWidth / 2) / oldWidth;
    var centreY = (canvas.scrollTop + canvas.clientHeight / 2) / oldHeight;
    var positionToken = ++zoomPositionToken;
    resultZoom = Math.max(1, Math.min(3, Math.round(target * 2) / 2));
    canvas.style.setProperty("--tv3-result-zoom", String(resultZoom));
    canvas.classList.toggle("is-zoomed", resultZoom > 1);
    canvas.setAttribute("aria-label", "Enlarged result at " + Math.round(resultZoom * 100) + " percent. Use the zoom controls, scroll to pan, or press Enter to reset.");
    var label = q("[data-tv3-result-zoom-label]", overlay);
    var out = q("[data-tv3-result-zoom-out]", overlay);
    var inside = q("[data-tv3-result-zoom-in]", overlay);
    var reset = q("[data-tv3-result-zoom-reset]", overlay);
    var helpTitle = q("[data-tv3-result-help-title]", overlay);
    var helpCopy = q("[data-tv3-result-help-copy]", overlay);
    if (label) label.textContent = Math.round(resultZoom * 100) + "%";
    if (out) out.disabled = resultZoom <= 1;
    if (inside) inside.disabled = resultZoom >= 3;
    if (reset) {
      reset.disabled = resultZoom <= 1;
      reset.hidden = resultZoom <= 1;
    }
    if (helpTitle) helpTitle.textContent = resultZoom > 1 ? "Drag to explore" : "Tap image to zoom";
    if (helpCopy) helpCopy.textContent = resultZoom > 1 ? "Choose Reset to see the full result." : "Or use the Zoom controls below.";
    function positionZoomedResult() {
      if (positionToken !== zoomPositionToken) return;
      if (resultZoom <= 1) {
        canvas.scrollLeft = 0;
        canvas.scrollTop = 0;
        return;
      }
      var targetX = keepCentre ? centreX : .5;
      var targetY = keepCentre ? centreY : .5;
      canvas.scrollLeft = Math.max(0, targetX * canvas.scrollWidth - canvas.clientWidth / 2);
      canvas.scrollTop = Math.max(0, targetY * canvas.scrollHeight - canvas.clientHeight / 2);
    }
    window.requestAnimationFrame(positionZoomedResult);
    window.setTimeout(positionZoomedResult, 210);
  }

  function initResultZoomPan() {
    var canvas = resultCanvas();
    if (!canvas) return;
    canvas.addEventListener("keydown", function (event) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        setResultZoom(resultZoom > 1 ? 1 : 2, true);
      } else if (event.key === "+" || event.key === "=") {
        event.preventDefault();
        setResultZoom(resultZoom + .5, true);
      } else if (event.key === "-") {
        event.preventDefault();
        setResultZoom(resultZoom - .5, true);
      } else if (event.key === "0") {
        event.preventDefault();
        setResultZoom(1, false);
      }
    });
    canvas.addEventListener("pointerdown", function (event) {
      if (resultZoom <= 1 || event.pointerType !== "mouse" || event.button !== 0) return;
      zoomDrag = { id: event.pointerId, x: event.clientX, y: event.clientY, left: canvas.scrollLeft, top: canvas.scrollTop };
      zoomDragMoved = false;
      canvas.classList.add("is-dragging");
      canvas.setPointerCapture(event.pointerId);
    });
    canvas.addEventListener("pointermove", function (event) {
      if (!zoomDrag || zoomDrag.id !== event.pointerId) return;
      var deltaX = event.clientX - zoomDrag.x;
      var deltaY = event.clientY - zoomDrag.y;
      if (Math.abs(deltaX) > 3 || Math.abs(deltaY) > 3) zoomDragMoved = true;
      canvas.scrollLeft = zoomDrag.left - deltaX;
      canvas.scrollTop = zoomDrag.top - deltaY;
      event.preventDefault();
    });
    function endZoomDrag(event) {
      if (!zoomDrag || zoomDrag.id !== event.pointerId) return;
      canvas.classList.remove("is-dragging");
      if (canvas.hasPointerCapture(event.pointerId)) canvas.releasePointerCapture(event.pointerId);
      zoomDrag = null;
    }
    canvas.addEventListener("pointerup", endZoomDrag);
    canvas.addEventListener("pointercancel", endZoomDrag);
  }

  function updateResultViewer(target) {
    var slides = resultSlides();
    var overlay = overlayFor("results");
    if (!slides.length || !overlay) return false;
    resultIndex = ((target % slides.length) + slides.length) % slides.length;
    var source = q("img", slides[resultIndex]);
    var caption = q("figcaption", slides[resultIndex]);
    var image = q("[data-tv3-result-image]", overlay);
    var current = q("[data-tv3-result-current]", overlay);
    var viewerCaption = q("[data-tv3-result-caption]", overlay);
    if (!source || !image) return false;
    image.src = source.currentSrc || source.src;
    image.alt = source.alt || "Dr Sknn before and after result";
    if (current) current.textContent = String(resultIndex + 1);
    if (viewerCaption) viewerCaption.textContent = caption ? caption.textContent.replace(/^\s*\d+\s*/, "") : "Current Before & After Studio result";
    return true;
  }

  function openResult(target, trigger) {
    if (!updateResultViewer(target)) return;
    setResultZoom(1, false);
    openOverlay("results", trigger);
  }

  function moveResult(delta) {
    if (updateResultViewer(resultIndex + delta)) setResultZoom(1, false);
  }

  function loadScript(src, marker) {
    if (!src) return Promise.resolve(false);
    var existing = document.querySelector('script[data-tv3-lazy-script="' + marker + '"]');
    if (existing) return Promise.resolve(true);
    return new Promise(function (resolve) {
      var script = document.createElement("script");
      script.src = src;
      script.async = true;
      script.dataset.tv3LazyScript = marker;
      script.onload = function () { resolve(true); };
      script.onerror = function () { resolve(false); };
      document.head.appendChild(script);
    });
  }

  function activateTemplateScripts(container) {
    return qa("script", container).reduce(function (chain, oldScript, index) {
      return chain.then(function () {
        return new Promise(function (resolve) {
          var script = document.createElement("script");
          Array.prototype.slice.call(oldScript.attributes).forEach(function (attribute) {
            script.setAttribute(attribute.name, attribute.value);
          });
          script.dataset.tv3HydratedScript = String(index + 1);
          if (oldScript.src) {
            script.onload = function () { resolve(true); };
            script.onerror = function () { resolve(false); };
          } else {
            script.textContent = oldScript.textContent;
          }
          oldScript.replaceWith(script);
          if (!oldScript.src) resolve(true);
        });
      });
    }, Promise.resolve());
  }

  function hydratePricing() {
    if (pricingPromise) return pricingPromise;
    var pricing = q("[data-drsknn-pricing-v3-embedded]", root);
    var source = q("[data-drsknn-pricing-v3-source]", root);
    if (!pricing || !source) return Promise.resolve(false);
    var controllerSrc = pricing.getAttribute("data-pricing-v3-script-src") || "";
    var sourceUrl = pricing.getAttribute("data-pricing-v3-source-url") || "";
    if (sourceUrl) sourceUrl += (sourceUrl.indexOf("?") === -1 ? "?" : "&") + "lines_release=20261017";

    pricing.dataset.tv3Loading = "true";
    pricingPromise = Promise.resolve().then(function () {
      if (source.firstElementChild) return true;
      return fetch(sourceUrl, { credentials: "same-origin", cache: "no-cache" })
        .then(function (response) {
          if (!response.ok) throw new Error("Pricing source unavailable");
          return response.text();
        }).then(function (html) {
          var parsed = new window.DOMParser().parseFromString(html, "text/html");
          var remoteSource = parsed.querySelector("[data-drsknn-pricing-v3-source]");
          if (!remoteSource) throw new Error("Pricing source missing");
          source.innerHTML = remoteSource.innerHTML;
          return true;
        });
    }).then(function () {
      return activateTemplateScripts(source);
    }).then(function () {
      if (pricing.dataset.pricingV3Ready === "true") return true;
      return loadScript(controllerSrc, "pricing-v3");
    }).then(function (loaded) {
      pricing.dataset.tv3Loading = "false";
      pricing.dataset.tv3Loaded = loaded ? "true" : "failed";
      return loaded;
    }).catch(function () {
      pricing.dataset.tv3Loading = "false";
      pricing.dataset.tv3Loaded = "failed";
      var areaGrid = q("[data-pv3-area-grid]", pricing);
      if (areaGrid) areaGrid.innerHTML = '<p class="drsknn-pricing-v3__loading" role="status">Prices could not load. <a href="/?price_route=search&amp;pricing=antiwrinkle#drsknn-home-v2-pricing">Open the full price list</a>.</p>';
      return false;
    });
    return pricingPromise;
  }

  var tv3ParentBridge = null;
  function ensureTv3ParentBridge(frame) {
    var api = window.DRSKNN_BOOKING_PARENT_BRIDGE;
    if (!api || !frame) return null;
    if (!tv3ParentBridge) tv3ParentBridge = api.register(frame, { completionOwner: true });
    return tv3ParentBridge;
  }
  window.addEventListener("drsknn:booking-parent-bridge-ready", function () {
    var frame = q("[data-tv3-booking-frame]", root);
    if (frame && frame.getAttribute("src")) {
      var bridge = ensureTv3ParentBridge(frame);
      if (bridge) bridge.sendPrivacy();
    }
  });

  function bookingUrl(role) {
    role = "doctor";
    var url = new URL("https://www.drsknn.uk/kiosk/v4/consultation/" + encodeURIComponent(role));
    var landingSource = root.dataset.landingSource || root.dataset.treatmentHandle || "treatment_v3";
    var params = {
      source: "treatment_v3",
      landing_source: landingSource,
      embed: "1",
      embedded: "1",
      booking_embed: "treatment_v3_modal",
      hide_cookie_banner: "1",
      hide_cookie_notice: "1",
      hide_iubenda: "1",
      skip_cookie_policy: "1",
      parent_domain: window.location.hostname,
      website_cookie_consent_status: "handled_on_parent_site",
      website_cookie_consent_ref: "drsknn_" + window.location.hostname.replace(/^www\./, "").split(".").pop() + "_v5_iubenda",
      booking_return: "v5_completion_v2",
      return_url: window.location.origin + window.location.pathname
    };
    Object.keys(params).forEach(function (key) { url.searchParams.set(key, params[key]); });
    return url.toString();
  }

  function openBooking(role) {
    var chooser = q("[data-tv3-consultation-chooser]", root);
    var booking = q("[data-tv3-booking]", root);
    var frame = q("[data-tv3-booking-frame]", root);
    if (!booking || !frame) return;
    if (chooser) chooser.hidden = true;
    booking.hidden = false;
    ensureTv3ParentBridge(frame);
    frame.setAttribute("referrerpolicy", "no-referrer");
    frame.src = bookingUrl(role);
  }

  window.DrSknnTreatmentV3OpenBooking = openBooking;
  function bindContainedPageLinks() {
    qa('a[href*="/pages/dr-sknn-home-v2-preview?open=consultation"], a[href*="/pages/dr-sknn-home-v2-preview?price_route="]').forEach(function (link) {
      if (root.contains(link) || link.dataset.tv3ContainedBound === "true") return;
      link.dataset.tv3ContainedBound = "true";
      link.addEventListener("click", function (event) {
        var href = link.getAttribute("href") || "";
        var action = href.indexOf("open=consultation") !== -1 ? "consultation" : "pricing";
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        openOverlay(action, link);
      }, true);
    });
  }

  function initTreatmentReviews() {
    if (preserveOriginBehaviour) return;
    var section = q("[data-tv3-reviews]", root);
    if (!section || section.dataset.tv3ReviewsReady === "true") return;
    section.dataset.tv3ReviewsReady = "true";

    var track = q("[data-tv3-reviews-track]", section);
    var status = q("[data-tv3-reviews-status]", section);
    var previous = q("[data-tv3-reviews-prev]", section);
    var next = q("[data-tv3-reviews-next]", section);
    var googleSummary = q("[data-tv3-review-google-summary]", section);
    var pabauSummary = q("[data-tv3-review-pabau-summary]", section);
    var googleLink = q("[data-tv3-review-google-link]", section);
    var filterButtons = qa("[data-tv3-review-filter]", section);
    if (!track || !status) return;

    var state = {
      loaded: false,
      loading: false,
      filter: "featured",
      google: [],
      pabau: [],
      googleRating: 0,
      googleCount: 0,
      pabauCount: 0
    };
    var matchStopWords = [
      "about", "and", "area", "areas", "cheshire", "clinic", "consultation", "doctor", "dr",
      "for", "from", "guide", "medical", "option", "options", "result", "results", "service",
      "skin", "sknn", "the", "therapy", "treatment", "treatments", "wilmslow", "with"
    ];
    var broadSingleTerms = [
      "ageing", "aging", "anti", "area", "body", "face", "facial", "filler", "hair", "injection",
      "ipl", "laser", "led", "line", "remove", "rejuvenation", "scalp", "skin"
    ];
    var treatmentLexicon = [
      "acne treatment", "anti ageing", "anti aging", "anti wrinkle", "botox", "chemical peel",
      "co2", "dermal filler", "dermalux", "exosome", "filler", "hair reduction", "hair removal",
      "hifu", "hydrafacial", "hydrofacial", "ipl", "laser", "led", "mh10", "microneedling",
      "nctf", "onda", "polynucleotide", "prp", "profhilo", "rosacea treatment", "skin booster",
      "thread lift"
    ];

    function cleanReviewValue(value, limit) {
      var text = value == null ? "" : String(value);
      text = text.replace(/[\r\n\t]+/g, " ").replace(/\s+/g, " ").trim();
      return limit ? text.slice(0, limit) : text;
    }

    function normaliseReviewValue(value) {
      return cleanReviewValue(value).toLowerCase().replace(/&/g, " and ").replace(/[_-]+/g, " ").replace(/[^a-z0-9 ]+/g, " ").replace(/\s+/g, " ").trim();
    }

    function uniqueReviewValues(values) {
      var seen = {};
      return values.filter(function (value) {
        if (!value || seen[value]) return false;
        seen[value] = true;
        return true;
      });
    }

    function reviewTagValues(tags) {
      if (!tags || typeof tags !== "object") return [];
      var values = [];
      ["area_ids", "areas", "category_ids", "categories", "concern_ids", "concerns"].forEach(function (key) {
        var current = tags[key];
        if (Array.isArray(current)) values = values.concat(current);
        else if (typeof current === "string") values = values.concat(current.split(","));
      });
      return values.map(normaliseReviewValue).filter(Boolean);
    }

    function canonicalReviewToken(value) {
      var token = normaliseReviewValue(value);
      var aliases = {
        reductions: "remove", reduction: "remove", removal: "remove", removed: "remove",
        wrinkles: "wrinkle", injections: "injection", fillers: "filler",
        pigments: "pigment", pigmentation: "pigment", cheeks: "cheek",
        exosomes: "exosome", polynucleotides: "polynucleotide"
      };
      return aliases[token] || token;
    }

    function reviewTokens(value) {
      return uniqueReviewValues(normaliseReviewValue(value).split(" ").map(canonicalReviewToken).filter(function (word) {
        return word.length >= 3 && matchStopWords.indexOf(word) === -1;
      }));
    }

    var reviewKeywordGroups = (section.getAttribute("data-review-keywords") || "").split("|").map(function (value) {
      var phrase = normaliseReviewValue(value);
      return { phrase: phrase, tokens: reviewTokens(phrase) };
    }).filter(function (group) {
      return group.phrase && group.tokens.length;
    });

    function reviewMatchScore(review) {
      var service = normaliseReviewValue(review.service);
      if (!service) return 0;
      var serviceWords = reviewTokens(service);
      var serviceSet = {};
      serviceWords.forEach(function (word) { serviceSet[word] = true; });
      var paddedService = " " + service + " ";
      return reviewKeywordGroups.reduce(function (best, group) {
        if (group.tokens.length >= 2 && paddedService.indexOf(" " + group.phrase + " ") !== -1) {
          return Math.max(best, 12 + group.tokens.length);
        }
        var overlap = group.tokens.reduce(function (count, word) {
          return count + (serviceSet[word] ? 1 : 0);
        }, 0);
        if (group.tokens.length === 1) {
          if (broadSingleTerms.indexOf(group.tokens[0]) !== -1) return best;
          return overlap === 1 ? Math.max(best, 6) : best;
        }
        var required = Math.max(2, Math.ceil(group.tokens.length * .66));
        return overlap >= required ? Math.max(best, overlap * 3) : best;
      }, 0);
    }

    function isGenericClinicReview(review) {
      var text = normaliseReviewValue([review.text, review.service, review.category].join(" "));
      if (!text) return false;
      var padded = " " + text + " ";
      return !treatmentLexicon.some(function (term) {
        return padded.indexOf(" " + term + " ") !== -1;
      });
    }

    function normaliseGoogleReview(review, index) {
      return {
        id: cleanReviewValue(review && (review.id || review.review_id || review.reviewId || review.time || ("google-" + index)), 120),
        source: "google",
        author: cleanReviewValue(review && (review.author_name || review.author || review.reviewer) || "Google reviewer", 70),
        rating: Math.max(1, Math.min(5, Math.round(Number(review && review.rating || 5)))),
        text: cleanReviewValue(review && (review.text || review.comment), 1600),
        date: cleanReviewValue(review && (review.date || review.relative_time_description || review.update_time || review.time), 80),
        service: "",
        category: "",
        tags: reviewTagValues(review && review.tags)
      };
    }

    function normalisePabauReview(review, index) {
      return {
        id: cleanReviewValue(review && (review.id || review.review_id) || ("pabau-" + index), 120),
        source: "pabau",
        author: "Verified patient",
        rating: Math.max(1, Math.min(5, Math.round(Number(review && review.rating || 5)))),
        text: cleanReviewValue(review && (review.text || review.feedback), 1600),
        date: cleanReviewValue(review && review.date, 80),
        service: cleanReviewValue(review && review.service, 120),
        category: cleanReviewValue(review && review.category, 120),
        tags: reviewTagValues(review && review.tags)
      };
    }

    function fetchReviewJson(url, timeout) {
      if (!url) return Promise.reject(new Error("Review endpoint unavailable"));
      var controller = typeof window.AbortController === "function" ? new window.AbortController() : null;
      var timer = window.setTimeout(function () { if (controller) controller.abort(); }, timeout || 9000);
      return fetch(url, {
        mode: "cors",
        credentials: "omit",
        signal: controller ? controller.signal : undefined
      }).then(function (response) {
        window.clearTimeout(timer);
        if (!response.ok) throw new Error("Review endpoint failed");
        return response.json();
      }, function (error) {
        window.clearTimeout(timer);
        throw error;
      });
    }

    function fetchGoogleReviews() {
      var primary = section.getAttribute("data-google-reviews-url") || "";
      var fallback = section.getAttribute("data-google-reviews-fallback-url") || "";
      return fetchReviewJson(primary, 20000).catch(function () { return fetchReviewJson(fallback, 20000); });
    }

    function rankedSafeReviews(reviews) {
      return reviews.map(function (review, index) {
        return { review: review, index: index, score: reviewMatchScore(review) };
      }).filter(function (item) {
        return item.review.text && (item.score > 0 || isGenericClinicReview(item.review));
      }).sort(function (left, right) {
        return right.score - left.score || right.review.rating - left.review.rating || left.index - right.index;
      });
    }

    function uniqueReviewItems(items) {
      var seen = {};
      return items.filter(function (item) {
        var key = item.review.source + "-" + item.review.id;
        if (seen[key]) return false;
        seen[key] = true;
        return true;
      });
    }

    function selectedReviews() {
      var google = rankedSafeReviews(state.google);
      var pabau = rankedSafeReviews(state.pabau);
      if (state.filter === "google") return google.slice(0, 3);
      if (state.filter === "pabau") return pabau.slice(0, 3);

      var matchedPabau = pabau.filter(function (item) { return item.score > 0; });
      var matchedGoogle = google.filter(function (item) { return item.score > 0; });
      var generalPabau = pabau.filter(function (item) { return item.score === 0; });
      var generalGoogle = google.filter(function (item) { return item.score === 0; });
      var featured = [];
      if (matchedPabau[0]) featured.push(matchedPabau[0]);
      else if (generalPabau[0]) featured.push(generalPabau[0]);
      if (matchedGoogle[0]) featured.push(matchedGoogle[0]);
      else if (generalGoogle[0]) featured.push(generalGoogle[0]);
      if (matchedPabau[1]) featured.push(matchedPabau[1]);
      else if (generalPabau[1]) featured.push(generalPabau[1]);
      return uniqueReviewItems(featured.concat(matchedPabau, matchedGoogle, generalPabau, generalGoogle)).slice(0, 3);
    }

    function appendTextElement(parent, tag, className, text) {
      var element = document.createElement(tag);
      if (className) element.className = className;
      element.textContent = text;
      parent.appendChild(element);
      return element;
    }

    function reviewCard(item) {
      var review = item.review;
      var matched = item.score > 0;
      var card = document.createElement("article");
      card.className = "drsknn-treatment-v3__review-card";
      card.setAttribute("data-tv3-review-card", "");

      var source = document.createElement("div");
      source.className = "drsknn-treatment-v3__review-card-source";
      appendTextElement(source, "span", "", review.source === "pabau" ? "Pabau · verified appointment" : "Google · public review");
      var stars = appendTextElement(source, "b", "", new Array(review.rating + 1).join("★") + new Array(6 - review.rating).join("☆"));
      stars.setAttribute("aria-label", review.rating + " out of 5 stars");
      card.appendChild(source);

      appendTextElement(card, "h3", "", matched && review.service ? review.service : (matched ? "Relevant patient feedback" : "General clinic experience"));
      var quote = document.createElement("blockquote");
      appendTextElement(quote, "p", "", review.text);
      card.appendChild(quote);

      if (review.text.length > 260) {
        var expand = appendTextElement(card, "button", "drsknn-treatment-v3__review-expand", "Read full review");
        expand.type = "button";
        expand.setAttribute("aria-expanded", "false");
        expand.addEventListener("click", function () {
          var expanded = card.classList.toggle("is-expanded");
          expand.setAttribute("aria-expanded", expanded ? "true" : "false");
          expand.textContent = expanded ? "Show less" : "Read full review";
        });
      }

      var footer = document.createElement("footer");
      appendTextElement(footer, "strong", "", review.author);
      appendTextElement(footer, "span", "", matched ? (review.service || "Review linked to this treatment route") : "Clinic-wide patient feedback");
      card.appendChild(footer);
      return card;
    }

    function updateReviewArrows() {
      if (!previous || !next) return;
      var maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      var overflow = maximum > 3;
      previous.hidden = !overflow;
      next.hidden = !overflow;
      previous.disabled = !overflow || track.scrollLeft <= 3;
      next.disabled = !overflow || track.scrollLeft >= maximum - 3;
    }

    function renderReviews() {
      var items = selectedReviews();
      track.replaceChildren();
      if (!items.length) {
        appendTextElement(track, "div", "drsknn-treatment-v3__reviews-empty", "Current review text is temporarily unavailable. Use the Google and Pabau source links above to read patient feedback.");
      } else {
        items.forEach(function (item) { track.appendChild(reviewCard(item)); });
      }
      track.scrollLeft = 0;
      filterButtons.forEach(function (button) {
        button.setAttribute("aria-pressed", button.getAttribute("data-tv3-review-filter") === state.filter ? "true" : "false");
      });
      var available = state.google.length + state.pabau.length;
      status.textContent = available
        ? "Showing " + items.length + " patient reviews. Treatment-linked feedback is prioritised where the source supports it."
        : "Use the Google and Pabau links to read current patient feedback.";
      window.requestAnimationFrame(updateReviewArrows);
    }

    function applyGooglePayload(payload) {
      var place = payload && payload.place || {};
      var reviews = Array.isArray(payload && payload.reviews) ? payload.reviews : (Array.isArray(place.reviews) ? place.reviews : []);
      state.google = reviews.map(normaliseGoogleReview).filter(function (review) { return !!review.text; });
      state.googleRating = Number(payload && payload.average_rating || place.rating || 0);
      state.googleCount = Number(payload && (payload.rating_count || payload.totalReviewCount) || place.user_rating_count || place.userRatingCount || state.google.length || 0);
      var destination = cleanReviewValue(place.url || place.googleMapsUri, 1200);
      if (googleLink && /^https:\/\//i.test(destination)) googleLink.href = destination;
    }

    function applyPabauPayload(payload) {
      var reviews = Array.isArray(payload && payload.reviews) ? payload.reviews : [];
      state.pabau = reviews.map(normalisePabauReview).filter(function (review) { return !!review.text; });
      state.pabauCount = Number(payload && (payload.total || payload.total_count || payload.totalCount) || state.pabau.length || 0);
    }

    function updateReviewSummaries() {
      if (googleSummary) {
        var rating = state.googleRating ? state.googleRating.toFixed(1) + " from " : "";
        googleSummary.textContent = state.googleCount ? rating + state.googleCount + " public ratings" : "Public patient reviews";
      }
      if (pabauSummary) pabauSummary.textContent = state.pabauCount ? state.pabauCount + " verified reviews" : "Verified appointment feedback";
    }

    function loadReviews() {
      if (state.loading || state.loaded) return;
      state.loading = true;
      status.textContent = "Loading current patient reviews…";
      Promise.all([
        fetchGoogleReviews().then(applyGooglePayload).catch(function () {}),
        fetchReviewJson(section.getAttribute("data-pabau-reviews-url") || "", 20000).then(applyPabauPayload).catch(function () {})
      ]).then(function () {
        state.loading = false;
        state.loaded = true;
        updateReviewSummaries();
        renderReviews();
      });
    }

    filterButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        state.filter = button.getAttribute("data-tv3-review-filter") || "featured";
        if (!state.loaded) loadReviews();
        else renderReviews();
      });
    });
    if (previous) previous.addEventListener("click", function () { track.scrollBy({ left: -Math.max(240, track.clientWidth * .88), behavior: "smooth" }); });
    if (next) next.addEventListener("click", function () { track.scrollBy({ left: Math.max(240, track.clientWidth * .88), behavior: "smooth" }); });
    track.addEventListener("scroll", updateReviewArrows, { passive: true });
    track.addEventListener("keydown", function (event) {
      if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
      event.preventDefault();
      track.scrollBy({ left: (event.key === "ArrowRight" ? 1 : -1) * Math.max(240, track.clientWidth * .88), behavior: "smooth" });
    });
    window.addEventListener("resize", updateReviewArrows, { passive: true });

    if (typeof window.IntersectionObserver === "function") {
      var observer = new window.IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        observer.disconnect();
        loadReviews();
      }, { rootMargin: "600px 0px" });
      observer.observe(section);
    } else {
      window.setTimeout(loadReviews, 500);
    }
  }

  bindContainedPageLinks();
  window.setTimeout(bindContainedPageLinks, 1000);
  window.setTimeout(bindContainedPageLinks, 5000);

  root.addEventListener("click", function (event) {
    var directConsultation = event.target.closest("[data-tv3-direct-consultation]");
    if (directConsultation) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      openOverlay("consultation", directConsultation);
      return;
    }
    var resultTrigger = event.target.closest("[data-tv3-open-result]");
    if (resultTrigger) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      openResult(Number(resultTrigger.getAttribute("data-tv3-open-result")) || 0, resultTrigger);
      return;
    }
    var detailTrigger = event.target.closest("[data-tv3-detail]");
    if (detailTrigger) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      openDetail(detailTrigger);
      return;
    }
    var zoomSurface = event.target.closest("[data-tv3-result-canvas]");
    if (zoomSurface) {
      event.preventDefault();
      event.stopPropagation();
      if (zoomDragMoved) {
        zoomDragMoved = false;
        return;
      }
      setResultZoom(resultZoom > 1 ? 1 : 2, true);
      return;
    }
    var zoomOut = event.target.closest("[data-tv3-result-zoom-out]");
    if (zoomOut) {
      event.preventDefault();
      event.stopPropagation();
      setResultZoom(resultZoom - .5, true);
      return;
    }
    var zoomIn = event.target.closest("[data-tv3-result-zoom-in]");
    if (zoomIn) {
      event.preventDefault();
      event.stopPropagation();
      setResultZoom(resultZoom + .5, true);
      return;
    }
    var zoomReset = event.target.closest("[data-tv3-result-zoom-reset]");
    if (zoomReset) {
      event.preventDefault();
      event.stopPropagation();
      setResultZoom(1, false);
      return;
    }
    var resultPrev = event.target.closest("[data-tv3-result-prev]");
    if (resultPrev) {
      event.preventDefault();
      event.stopPropagation();
      moveResult(-1);
      return;
    }
    var resultNext = event.target.closest("[data-tv3-result-next]");
    if (resultNext) {
      event.preventDefault();
      event.stopPropagation();
      moveResult(1);
      return;
    }
    var containedTrigger = event.target.closest("[data-tv3-open]");
    if (containedTrigger) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      openOverlay(containedTrigger.getAttribute("data-tv3-open"), containedTrigger);
      return;
    }
    var roleLink = event.target.closest("[data-tv3-book-role]");
    if (roleLink) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      openBooking(roleLink.getAttribute("data-tv3-book-role") || "doctor");
    }
  }, true);

  document.addEventListener("click", function (event) {
    var exactClose = event.target.closest("[data-pricing-close-modal], [data-pv3-guide-close]");
    var pricingOverlay = overlayFor("pricing");
    // Pricing V3 marks its synthetic close click when moving from an exact-price
    // card back to "All treatments" or "Back to matches". Keep the containing
    // pricing journey open only for that internal navigation.
    var preservePricingOverlay = exactClose && exactClose.getAttribute("data-pv3-preserve-pricing-overlay") === "true";
    if (exactClose && !preservePricingOverlay && pricingOverlay && pricingOverlay.classList.contains("is-open") && !suppressPricingClose) {
      window.setTimeout(function () { closeOverlay(pricingOverlay, { skipPricingClose: true }); }, 0);
      return;
    }

    var close = event.target.closest("[data-tv3-close]");
    if (close) {
      event.preventDefault();
      closeOverlay(close.closest("[data-tv3-overlay]"));
      return;
    }

    var bookingBack = event.target.closest("[data-tv3-booking-back]");
    if (bookingBack) {
      event.preventDefault();
      resetConsultation();
      return;
    }

    var role = event.target.closest("[data-tv3-book-role]");
    if (role) {
      event.preventDefault();
      openBooking(role.getAttribute("data-tv3-book-role") || "doctor");
      return;
    }

    var trigger = event.target.closest("[data-tv3-open], a[href]");
    if (!trigger) return;
    var action = trigger.getAttribute("data-tv3-open") || "";
    var href = trigger.getAttribute("href") || "";
    if (!action && href.indexOf("dr-sknn-home-v2-preview?open=consultation") !== -1) action = "consultation";
    if (!action && href.indexOf("dr-sknn-home-v2-preview?price_route=") !== -1) action = "pricing";
    if (!action || (action !== "consultation" && action !== "pricing")) return;
    event.preventDefault();
    openOverlay(action, trigger);
  });

  qa("[data-tv3-overlay]", root).forEach(function (overlay) {
    overlay.addEventListener("click", function (event) {
      if (event.target === overlay) closeOverlay(overlay);
    });
  });

  document.addEventListener("keydown", function (event) {
    // Pricing V3 owns focus, Escape and Tab while its exact-treatment dialog is open.
    // The outer Treatment dialog is inert during that interval, so it must not trap
    // the same keyboard event or close behind the nested dialog.
    if (!preserveOriginBehaviour && nestedPricingIsOpen()) return;
    if (event.key === "Escape" && activeOverlay) closeOverlay(activeOverlay);
    if (event.key === "Tab" && activeOverlay) {
      trapOverlayFocus(event);
      return;
    }
    if (!activeOverlay || activeOverlay.getAttribute("data-tv3-overlay") !== "results") return;
    if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
      if (resultZoom > 1 && event.target.closest("[data-tv3-result-canvas]")) return;
      event.preventDefault();
      moveResult(event.key === "ArrowRight" ? 1 : -1);
    }
  });


  function revealConcernAnchor() {
    var id;
    try { id = decodeURIComponent(window.location.hash.slice(1)); } catch (_) { return; }
    if (!id) return;
    var target = document.getElementById(id);
    if (!target || !root.contains(target) || !target.hasAttribute("data-tv3-area")) return;
    var ancestor = target.parentElement;
    while (ancestor && ancestor !== root) {
      if (ancestor.tagName === "DETAILS") ancestor.open = true;
      ancestor = ancestor.parentElement;
    }
    window.requestAnimationFrame(function () {
      target.scrollIntoView({ block: "start", behavior: "auto" });
      target.focus({ preventScroll: true });
    });
  }
  window.addEventListener("hashchange", revealConcernAnchor);
  revealConcernAnchor();

  initJumpNavigation();
  initProofFallback();
  initCarousel();
  initTreatmentVideos();
  initTreatmentReviews();
  initDirectBookingPicker();
  initResultZoomPan();
  initHeaderSearchBridge();
})();
